!(function (window, document, undefined) {
    'use strict';

    const $window = $(window);
    const $document = $(document);

    const translate = {
        'index': 'home',
    };

    const page = translate[$body.prop('id')];

    const trackEvent = (selector, event, trackEvent, trackCategory, trackLabel) => {
        $(selector).on(event, function () {
            if (typeof gtag !== "undefined") {
                gtag('event', trackEvent, { 'event_category': trackCategory, 'event_label': trackLabel });
            }
        });
    };

    const scrollCheckpoints = [25, 50, 75, 100];

    let scrollCurrentCheckpoint = 0;

    $window.on('scroll', function () {
        const scrollTop = $window.scrollTop();
        const percent = scrollTop / ($document.height() - $window.height()) * 100;

        if (percent > scrollCurrentCheckpoint) {
            const checkpoint = scrollCheckpoints.reduce((accumulator, currentValue) => {
                return percent >= currentValue ? currentValue : accumulator;
            }, 0);

            if (checkpoint !== scrollCurrentCheckpoint) {
                $document.trigger('luego-scroll-depth', [checkpoint]);

                scrollCurrentCheckpoint = checkpoint;
            }
        }
    });

    $document.on('luego-scroll-depth', function (e, checkpoint) {
        if (typeof gtag !== "undefined") {
            gtag('event', 'Scroll', { 'event_category': page, 'event_label': checkpoint });
        }
    });


    const removerAcentos = (str) => {
        var w,
            map = {
                a: /[\xE0-\xE6]/g,
                e: /[\xE8-\xEB]/g,
                i: /[\xEC-\xEF]/g,
                o: /[\xF2-\xF6]/g,
                u: /[\xF9-\xFC]/g,
                c: /\xE7/g,
                n: /\xF1/g
            };

        str = str.replace(/[?!.,@#$%&()]/g, '');
        str = str.replace(/ +\| +/g, ' ');

        for (w in map) {
            str = str.replace(map[w], w);
        }

        return str;
    };

    const toSpinal = (str) => {
        if (typeof str != 'undefined') {
            return removerAcentos(str).replace('NBA', 'Nba').split(/\s|_|(?=[A-Z])/).join('-').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        }
    };
    // Code here

    const GTMPush = function(data) {
        dataLayer.push(data);
    }

    const event = 'gaEvent';
    const eventCategory = 'Instituto BRF';

    $document.on('click', '[data-track]', function() {
        const track = $(this).data('track');

        GTMPush({
            'event': event,
            'eventCategory': toSpinal(track.category) || eventCategory,
            'eventAction': track.action || 'click',
            'eventLabel': toSpinal(track.label) || '',
            'eventType':'nano-conversion',
        });
    });

})(window, document, undefined);
